<template>
  <div class="row text-center mt-0 mb-0">
    <div class="col-md-12">
      <small class="text-muted d-block text-uppercase fw-bold mb-2" style="font-size: 11px; letter-spacing: 0.8px;">
        <i class="fa-solid fa-pen-nib me-1 text-primary"></i> Neue Signatur zeichnen
      </small>
      <canvas
          id="signature-canvas"
          width="350"
          height="200"
          style="border: 1px solid rgb(208, 208, 208);"
          ref="canvasRef"></canvas>
      <input v-model="formData.digitalSignature" type="hidden"/>
    </div>
  </div>

  <div class="digital-signature-image" v-if="existingDigitalSignature">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <div style="width: 350px; margin-bottom: 10px; margin-top: 10px;" class="text-center">
        <small class="text-muted d-block text-uppercase fw-bold mb-2"
               style="font-size: 11px;
               letter-spacing: 0.8px;">
          <i class="fa-solid fa-signature me-1 text-success"></i> Aktuelle Signatur
        </small>
        <img
            class="img-fluid shadow-sm"
            :src="existingDigitalSignature"
            alt="Signature"
            style="width: 100%; height: 150px; object-fit: contain; border: 1px solid #dee2e6; background-color: #f8f9fa; border-radius: 6px; padding: 10px;"
          />
      </div>
    </div>
  </div>

  <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center modal-buttons mt-3 pt-3 border-top w-100 gap-2" style="border-top-color: #eef1f5 !important;">

    <button class="btn btn-soft-red fw-bold me-0 me-md-3 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center" style="min-height: 38px;" @click="clearSignature">
      <i class="fa-solid fa-eraser me-2"></i> {{ $t('general.button.delete') }}
    </button>

    <button class="btn btn-primary fw-bold ms-0 ms-md-3 mt-3 mt-md-0 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center" style="min-height: 38px;" @click="saveSignature">
      <i class="fa-solid fa-floppy-disk me-2"></i> {{ $t('general.button.save') }}
    </button>

  </div>
</template>

<script setup>
import unemployedService from '@/api/Unemployed';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import SignaturePad from 'signature_pad';
import { defineEmits, defineProps, onMounted, ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const emit                     = defineEmits([ 'update:modelValue', 'update:submitForm', 'updateDigitalSignature' ]);
const { t }                    = useI18n();
const canvasRef                = ref(null);
const existingDigitalSignature = ref('');
const isLoaded                 = ref(false);
let signaturePad               = null;

const props = defineProps({
  unemployedId: {
    type: [ Number, String ],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const unemployedId = toRefs(props)[ 'unemployedId' ];

const formData = ref({
  digitalSignature: '',
  unemployedId: +unemployedId.value,
});

async function saveSignature() {
  if (signaturePad && !signaturePad.isEmpty()) {
    emit('updateDigitalSignature', true);
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    emit('updateDigitalSignature', false);
    formData.value.digitalSignature = ''; // Clear if empty
  }

  try {
    await unemployedService.saveDigitalSignature(formData.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

async function getUnemployedData() {
  try {
    const { data }   = await unemployedService.getUnemployed(unemployedId.value);
    const unemployed = data.data;

    existingDigitalSignature.value = unemployed?.digitalSignatureBase64;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  await getUnemployedData();

  isLoaded.value = true;
});
</script>

<style scoped>
canvas {
  cursor: crosshair;
}

.btn-soft-red {
  color: #a51d24;
  background-color: #fce8e6;
  border: 1px solid #f8c2be;
  transition: all 0.15s ease-in-out;
}

.btn-soft-red:hover {
  color: #ffffff;
  background-color: #a51d24;
  border-color: #a51d24;
}

.btn i {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>